
<template>
  <div>
    <Head :title="`${$t('treatments.treatment')} #${data.id}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <span v-if="viaVolunteer" class="text-gray-400">
        {{ data.applicant_details.id }}. {{ data.applicant_details.name }}
      </span>
      <Link v-else class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_details.id}/view`">
        {{ data.applicant_details.id }}. {{ data.applicant_details.name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ $t('treatment-types.'+data.treatment_type_name) }}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore">
      {{ $t('applicants.trashed_message') }}
    </trashed-message>
    <div class="grid gap-4 lg:grid-cols-3 grid-cols-1">
      <panel-applicant :applicant="data.applicant_details" :viaVolunteer="viaVolunteer" />
      <panel-treatment :treatment="data" :viaVolunteer="viaVolunteer" />
      <panel-note :treatment="data" :viaVolunteer="viaVolunteer" />

      <div v-if="data.treatment_type_id == 5" class="lg:col-span-3 col-span-1 mt-5">
        <div class="flex gap-5 items-center mb-5">
          <h2 class="font-bold text-2xl">
            {{ $t('interventions.logements') }}
          </h2>
          <Link
            class="bg-green-500 hover:bg-green-700 text-black text-center py-3 px-4 rounded-full h-12 w-12 inline-flex items-center"
            :href="`/applicants/${data.applicant_id}/treatments/${data.id}/treatment-logements/create`"
          >
            <icon name="plus" class="h-5 w-5 fill-current text-white" />
          </Link>
        </div>
        <Table
          :resource="logements"
          name="logements"
          class="custom-table-layout rounded"
          preserve-scroll="table-top"
        >
          <template #cell(date_start)="{ item: data }">
            {{ $filters.formatDate(data.date_start) }}
          </template>
          <template #cell(date_end)="{ item: data }">
            {{ $filters.formatDate(data.date_end) }}
          </template>
          <template #cell(status)="{ item: data }">
            <status-badge :status="data.status" />
          </template>
        </Table>
      </div>
      <div class="lg:col-span-3 col-span-1 mt-5">
        <div class="flex gap-5 items-center mb-5">
          <h2 class="font-bold text-2xl">
            {{ $t('interventions.interventions') }}
          </h2>
          <Link
            class="bg-green-500 hover:bg-green-700 text-black text-center py-3 px-4 rounded-full h-12 w-12 inline-flex items-center"
            :href="`/applicants/${data.applicant_id}/treatments/${data.id}/interventions/create`"
          >
            <icon name="plus" class="h-5 w-5 fill-current text-white" />
          </Link>
        </div>
        <Table
          :resource="interventions"
          name="interventions"
          class="custom-table-layout rounded"
          preserve-scroll="table-top"
        >
          <template #cell(date)="{ item: intervention }">
            {{ $filters.formatDate(intervention.date) }}
          </template>
        </Table>
      </div>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TrashedMessage from '@/Shared/TrashedMessage'
import Icon from '@/Shared/Icon'
import StatusBadge from '@/Shared/StatusBadge'
import Table from '@/Shared/Table/Components/Table'
import PanelApplicant from '@/Pages/Applicants/Panels/Applicant'
import PanelTreatment from '@/Pages/Applicants/Panels/Treatment'
import PanelNote from '@/Pages/Treatments/Panels/Note'

export default {
  components: {
    Head,
    Link,
    StatusBadge,
    TrashedMessage,
    Icon,
    Table,
    PanelApplicant,
    PanelTreatment,
    PanelNote
  },
  layout: Layout,
  props: {
    data: Object,
    auth: Object,
    treatment_types: Object,
    interventions: Object,
    logements: Object,
  },
  remember: 'form',
  computed: {
    viaVolunteer(){
      return this.auth.user.isVolunteer
    }
  },
  data() {
    return {
      form: this.$inertia.form({
        reason_closed: this.data.reason_closed,
        treatment_type_id: this.data.treatment_type_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/treatments/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/treatments/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/applicants/${this.data.applicant_id}/treatments/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
